var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"rich-text-wrapper"},[(_vm.type === 2)?_c('span',{staticClass:"v-html",domProps:{"innerHTML":_vm._s(_vm.content)}}):_c('span',[_vm._v(_vm._s(_vm.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }